import React, { Component } from 'react'
import { post } from '../../Utils'
import Text from '../../Components/Text'
import ReactSVG from 'react-svg'
import './newsletter.css'

class Newsletter extends Component {

	constructor(props){
		super(props)
		this.state = {
			inputValue: '',
		    v_email: '',
		    v_check: '',
			errors: false,
			message: ''
		}
		this.onSubmit = this.onSubmit.bind(this)
		this.onChange = this.onChange.bind(this)
		this.onChangeCheck = this.onChangeCheck.bind(this)
	}

	onChange(evt){
		const inputValue = evt.currentTarget.value;
		var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,15})+$/;
		const v_email = inputValue.match(mailformat) ? true : false 
		this.setState({
			v_email,
			inputValue
		})    
	}

	onChangeCheck(evt){
		const inputCheck = evt.currentTarget.value;
		const v_check = inputCheck ? true : false    

		this.setState({
			v_check
		})    
	}

	onSubmit(evt){
		const {inputValue,v_email, v_check} = this.state
		const { action } = this.props
		const messageResponse = evt.currentTarget.closest('#newsletter').dataset.msg
		evt.preventDefault()
        var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,15})+$/;
        const errors = inputValue.match(mailformat) ? false : true 

        this.setState({
        	errors,
        	preloader: true
        })

        if(!errors){

        	post(action, { 'emailAddress':inputValue }).then(()=>{
        		this.setState({message: messageResponse,preloader: false})
        	})
        }else{
	        this.setState({
		        v_check: v_check === '' ? false : v_check,
		        v_email: v_email === '' ? false : v_email,
	        	preloader: false
	        })
        }

	}

	render(){
		const { title, text, placeholder, buttonText, action, label } = this.props
		const { message, v_email, v_check} = this.state
		return (
			<div>
				<div className="title" >{title}</div>
				<Text text={text} />
				<form action={action} onSubmit={this.onSubmit}>
					<input type="text" placeholder={placeholder} className={v_email === true || v_email === '' ? '': 'error'} onChange={this.onChange} />
					<button className={this.state.preloader === true ? "js-active" : ""}>
						<span>{buttonText}</span>
						<div className="preloader">
							<ReactSVG path="/static/img/logoshape.svg" />
						</div>
					</button>
					<div className={v_check === true || v_check === '' ? "row row--checkbox" : "row row--checkbox error"}>
						<input type="checkbox" id="optin_newsletter" name="optin_newsletter" value="on" onChange={this.onChangeCheck}/>
						<label htmlFor="optin_newsletter">{label}</label>
					</div>
					<div className="message">{message}</div>
				</form>
			</div>
		)
	}
}
export default Newsletter


// WEBPACK FOOTER //
// ./src/Containers/Newsletter/index.js